<template>
    <div class="container">
        <div class="rd-card rd-card--border-top">
            <template v-if="!completed">
                <h2 class="contact-dealer-form__title">
                    Complete the form below to enquire about this {{ vehicle.manufacturer }} {{ vehicle.model }}
                </h2>
                <form ref="form" method="post" data-form-name="Used Vehicles - Contact Dealer">
                    <input type="hidden" name="vehicle-id" :value="vehicle.id">
                    <div class="form-grid form-grid--xs-1-column">
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <title-input />
                        </div>
                        <div class="form-grid__col form-grid__col--xs-full-width">
                            <first-name />
                        </div>
                        <div class="form-grid__col form-grid__col--xs-full-width">
                            <last-name />
                        </div>
                        <div class="form-grid__col form-grid__col--xs-full-width">
                            <email />
                        </div>
                        <div class="form-grid__col form-grid__col--xs-full-width">
                            <telephone :inputNullable="false" inputValidateMessage="Please enter a telephone number" />
                        </div>
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <generic-textarea input-name="message" input-title="Anything you'd like to ask?"
                                :input-validate="false"></generic-textarea>
                        </div>
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <privacy />
                        </div>
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <button @click.prevent="submit" type="button"
                                class="btn btn--primary btn--full-width-xs">Enquire Now</button>
                        </div>
                    </div>
                </form>
            </template>
            <div v-else>
                <h2>Thank you for your {{ vehicle.manufacturer }} {{ vehicle.model }} enquiry</h2>
                <p class="nice-text">
                    A member of the team will be in contact shortly to discuss your enquiry. Please use the link below to
                    receive a free, instant valuation for your current vehicle
                </p>
                <a href="/car-valuation" class="btn btn--primary">Value my car</a>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from "../../core/components/Modal.vue";
import TitleInput from "./Forms/redesign/Title.vue";
import FirstName from "./Forms/redesign/FirstName.vue";
import LastName from "./Forms/redesign/LastName.vue";
import Email from "./Forms/redesign/Email.vue";
import Telephone from "./Forms/redesign/Telephone.vue";
import GenericTextarea from "./Forms/redesign/GenericTextarea.vue";
import Privacy from "./Forms/redesign/Privacy.vue";

export default {
    components: {
        GenericTextarea,
        Modal,
        TitleInput,
        FirstName,
        LastName,
        Email,
        Telephone,
        Privacy
    },
    props: {
        open: {
            default: false,
        },
        vehicle: {
            default: false,
        },
    },
    data() {
        return {
            validator: false,
            completed: false,
        };
    },
    methods: {
        async submit() {
            if (!await this.validator.isValid()) {
                return false;
            }

            reCaptchaProtect(() => {
                const formData = new FormData(this.$refs.form);
                this.validator.preventInput();

                axios.post('/api/used-vehicles/contact-dealer/' + this.vehicle.id, formData)
                    .then(response => {
                        this.gaTag('Used Vehicle', 'Contact Dealer', 'Complete');
                        this.generateLeadEvent('used_contact_dealer');
                        this.trackPageView('/conversion/used-vehicle-contact-dealer/complete', 'Used Vehicle Contact Dealer Completed');

                        this.completed = true;

                        this.validator.allowInput();
                    })
                    .catch(e => {
                        console.error('Used Details ContactDealerForm submit error', e);
                        this.validator.errorResponse(e);
                    })
            });
        },
    },
    mounted() {
        this.validator = new ContactFormValidator({
            element: this.$refs.form,
            vueForm: false,
        });
    }
}
</script>

<style lang="scss" scoped>
.contact-dealer-form {
    &__title {
        font-weight: 700;
        font-size: 16px;
        text-align: left;
        margin-bottom: 10px;
        margin-left: auto;
    }
}</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/ContactDealerForm.vue